<template>
  <div class="fixed inset-0 z-[123456789000] flex items-center justify-center bg-slate-900/40 backdrop-blur-sm transition-opacity animate-in fade-in duration-300">
    
    <div class="w-[90%] max-w-lg overflow-hidden rounded-2xl bg-white shadow-2xl border border-slate-100 animate-in zoom-in-95 slide-in-from-bottom-8 duration-500">
      
      <div class="flex items-center justify-between px-8 py-6 border-b border-slate-100">
        <h2 class="text-2xl font-semibold text-slate-800 tracking-tight leading-none">
          {{ title }}
        </h2>
      </div>

      <div class="p-8">
        <div class="flex flex-col gap-5">
          
          <div class="flex justify-between items-end">
            <div class="flex flex-col">
              <span class="text-xs font-bold uppercase tracking-wider text-slate-400 mb-1">Status</span>
              <span class="text-sm font-medium text-slate-600">
                {{ processedItems }} <span class="text-slate-300">/</span> {{ totalItems }}
              </span>
            </div>
            <div class="text-right">
              <span class="text-3xl font-bold text-[#386f99] tabular-nums">
                {{ progressPercentage }}%
              </span>
            </div>
          </div>

          <div class="relative h-4 w-full bg-slate-100 rounded-full overflow-hidden shadow-inner">
            <div
              class="h-full bg-[#386f99] rounded-full transition-all duration-700 ease-out relative"
              :style="{ width: progressPercentage + '%' }"
            >
              <div class="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shine"></div>
            </div>
          </div>

          <div class="text-center">
            <span 
              v-if="progressPercentage < 100" 
              class="text-sm font-medium text-slate-500 flex items-center justify-center gap-2"
            >
             <Loader class="w-5 h-5" />
              Processing in progress...
            </span>
            <span v-else class="text-sm font-bold text-emerald-500 flex items-center justify-center gap-1">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"></path>
              </svg>
              Done!
            </span>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '../Loader.vue';

export default {
  name: "ProgressModal",
  components:{
    Loader
  },
  props: {
    title: {
      type: String,
      default: "Loading",
    },
    progressIndicator: {
      type: Number,
      default: 0,
      validator: (value) => value >= 0 && value <= 100,
    },
    processedItems: {
      type: Number,
      default: 0,
    },
    totalItems: {
      type: Number,
      default: 100,
    },
  },
  computed: {
    progressPercentage() {
      if (this.progressIndicator > 0) {
        return Math.min(Math.max(this.progressIndicator, 0), 100);
      }
      return this.totalItems > 0
        ? Math.round((this.processedItems / this.totalItems) * 100)
        : 0;
    },
  },
};
</script>

<style scoped>
@keyframes shine {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

.animate-shine {
  animation: shine 2s infinite;
}
</style>